module.exports = __webpack_public_path__ + "static/img/bg_tw.696a1b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bfSaled-2025/bg_tw.png
// module id = fdLw
// module chunks = 1